import { FETCH_FINAL_CHARGES_REQUEST, FETCH_FINAL_CHARGES_SUCCESS, FETCH_FINAL_CHARGES_FAILURE, FETCH_FINAL_CHARGES_RESET, } from "../../actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const finalChargesLogReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_FINAL_CHARGES_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case FETCH_FINAL_CHARGES_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, data: null, error: null });
        case FETCH_FINAL_CHARGES_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload, data: null });
        case FETCH_FINAL_CHARGES_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, data: null, error: null });
        default:
            return state;
    }
};
export default finalChargesLogReducer;
